<template>
<fragment>
    <div class="product-single-container product-single-default">
        <div class="row">
            <product-width :key="keyProductImage" class="col-lg-7 col-md-6 mb-2">
                <template v-if="mediaDesktop">
                    <div class="product-single-gallery">
                        <div class="product-slider-container product-item">
                            <div class="product-single-carousel owl-carousel owl-theme">
                                <template
                                    v-for="imgs in item.images"
                                >
                                    <div class="product-item"
                                        v-if="imgs.is_table_size==false"
                                        :key="imgs.id"
                                        @click.prevent="$refs.imgplus.click()"
                                    >
                                        <img
                                            class="product-single-image"
                                            :src="imgs.url"
                                            :data-zoom-image="imgs.url"
                                            :alt="item.pro_name_site"
                                            loading="lazy"
                                            :style="`object-fit: contain; max-height: ${maxHeightImage}`"
                                        />
                                    </div>
                                </template>
                            </div>
                            <span class="prod-full-screen">
                                <i class="icon-plus" ref="imgplus"></i>
                            </span>
                        </div>
                        <div class="prod-thumbnail row owl-dots" id='carousel-custom-dots'>
                            <template v-for="imgs in item.images">
                                <div class="col-3 owl-dot" v-if="imgs.is_table_size==false" :key="imgs.id">
                                    <img
                                        :src="imgs.url"
                                        alt=""
                                        loading="lazy"
                                        :style="'object-fit: contain; '+(maxHeightImage == 'none' ? '' : `max-height: calc(${maxHeightImage} / 4)`)"
                                    />
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div
                        id="carouselProductsBootstrap"
                        class="carousel slide"
                        data-ride="carousel"
                        style="width: 100%; margin-top: 10px;"
                        data-interval="10000"
                    >
                        <div class="carousel-inner">
                            <div class="carousel-item active" :id="'carousel-item-'+item.id">
                                <img
                                    class="d-block w-100"
                                    :src="item.image_main"
                                    :alt="item.pro_name_site"
                                    :style="`object-fit: contain; max-height: ${maxHeightImage}`"
                                >
                            </div>
                            <template v-for="(img, key) in item.images">
                                <div v-if="img.url != item.image_main && img.is_table_size==false" :key="key" class="carousel-item" :id="'carousel-item-'+img.id">
                                    <img
                                        class="d-block w-100"
                                        :src="img.url"
                                        :alt="item.pro_name_site"
                                        loading="lazy"
                                        :style="`object-fit: contain; max-height: ${maxHeightImage}`"
                                    >
                                </div>
                            </template>
                        </div>
                        <template v-if="hasControlsCarousel">
                            <a class="carousel-control-prev" href="#carouselProductsBootstrap" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Anterior</span>
                            </a>
                            <a class="carousel-control-next" href="#carouselProductsBootstrap" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Próximo</span>
                            </a>
                        </template>
                    </div>
                    <ol class="carousel-indicators row"
                        style="position: relative; bottom: 0;
                            justify-content: start;
                            margin: 10px 0px 0px 0px;
                            width: 100%;"
                    >
                        <li data-target="#carouselProductsBootstrap"
                            style="width:70px; height:auto; margin: 0px 10px 10px 0;"
                            class="active"
                            @click="controlsIndicatorsSlider(item.id)"
                        >
                            <img
                                :src="item.image_main"
                                alt=""
                                loading="lazy"
                                :style="'object-fit: contain; '+(maxHeightImage == 'none' ? '' : `max-height: calc(${maxHeightImage} / 4)`)"
                            >
                        </li>
                        <template v-for="(i) in item.images">
                            <li :key="i.id"
                                v-if="i.url != item.image_main && i.is_table_size==false"
                                data-target="#carouselProductsBootstrap"
                                style="width:85px; height:auto; margin: 0px 10px 10px 0;"
                                @click="controlsIndicatorsSlider(i.id)"
                            >
                                <img
                                    :src="i.url"
                                    alt=""
                                    loading="lazy"
                                    :style="'object-fit: contain; '+(maxHeightImage == 'none' ? '' : `max-height: calc(${maxHeightImage} / 4)`)"
                                >
                            </li>
                        </template>
                    </ol>
                </template>
            </product-width>

            <div class="col-lg-5 col-md-6">
                <div class="product-single-details" :style="'font-family:'+$root.$children[0].theme.font_family">
                    <product-title>
                        <template v-if="showCodeOriginal">{{ item.api_cod_original }} - </template>
                        {{ product_name_site }}
                    </product-title>

                    <Rating
                        v-if="showRatings"
                        :item="item"
                        :showTotalReviews="true"
                    />
                    <br/>

                    <ProductPrice v-if="!hidePrice" :product="item" />

                    <template v-else>
                        <c-span style="font-size: 1.5rem; display: inline-block; margin: 0.5rem 0">
                            Faça login para ter acesso às ações de {{ isBudgetLayout ? 'orçamento' : 'compra' }} e aos preços, clicando no botão abaixo.
                        </c-span><br>
                        <c-ancora
                            :backgroundColor="$root.$children[0].theme.products.button.background_color"
                            :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                            :color="$root.$children[0].theme.products.button.color"
                            :colorHover="$root.$children[0].theme.products.button.color_hover"
                            :borderColor="$root.$children[0].theme.products.button.border_color"
                            :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                            :borderRadius="$root.$children[0].theme.products.button.border_radius"
                            :href="$baseUrl+'login'"
                            padding="0.85rem 2.5rem"
                            class="mt-1 mb-2"
                            title="Entrar"
                        >
                            <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">
                                Entrar
                            </span>
                        </c-ancora>
                    </template>

                    <template v-if="products_settings.show_payment_flags_product_page == true">
                        <ul v-if="payment_flags.length > 0" class="d-flex align-items-center row" style="margin: 2.8rem 0 2.4rem;">
                            <li v-for="flag in payment_flags"
                                :key="flag.id"
                                class="mr-3 mb-2"
                            >
                                <img style="max-width: 35px;" :data-src="flag.image" :alt="flag.company || flag.label" loading="lazy">
                            </li>
                        </ul>
                       <img v-if="payment_flags.length < 1" alt="Meios de pagamento" :data-src="$baseUrl+'assets/images/payments.png'" style="max-width: 200px; margin: 2.8rem 0 2.4rem;" loading="lazy">
                    </template>

                    <div class="product-desc" :style="'color: '+text_site_color">
                        <p v-if="item.pro_desc_min" v-html="item.pro_desc_min" style="line-height: 20px; margin-bottom: 0;"></p>
                    </div>



                    <template v-if="locale_linked_products == 2">
                        <ProductSideVariations
                            :v.sync="$v"
                            @selectedVariation="selectedVariation"
                        />
                    </template>

                    <ProductOptionsConversionUnity
                        :item.sync="item"
                    />

                    <ProductItemsGrid
                        v-if="showItemsGrid"
                        :validate.sync="$v"
                        :item_grid.sync="item_grid"
                        @handleSelectItemGrid="handleSelectItemGrid"
                    />

                    <ProductFractionalSale v-if="item.fractional_sale" />

                    <template v-if="linked_products.length == 0 || locale_linked_products == 2">
                        <ProductActions
                            local="page"
                            :item="item"
                            :isProductCustomization="isProductCustomization"
                            :activateProductCustomization="activateProductCustomization"
                            @addCart="addCart"

                            @showModalProductCustomization="showModalProductCustomization"
                        />
                        <div v-if="!isBudgetLayout && item.free_shipping" class="">
                            <ul>
                                <li style="display:flex; align-items:center">
                                    <i class="icon-shipping" style="color:#202020; font-size:4rem"></i>
                                    <strong
                                        style="text-transform: uppercase;"
                                    >
                                        <c-span>FRETE GRÁTIS</c-span>
                                    </strong>
                                </li>
                            </ul>
                        </div>
                        <CalculaFrete v-if="!item.free_shipping && !item.price_on_request"
                            :product_id="item.id"

                        />
                    </template>
                        <div v-if="share || share.length > 0" class="product-single-share">
                        <label :style="'color:'+$root.$children[0].theme.primary_color">Compartilhar:</label>
                        <ShareButton :buttons="share" />
                    </div>
                    <LinkYoutube :item="item" />
                </div>
                <div v-if="item.image_stamp.url_stamp" class="image_stamp">
                       <img :src="item.image_stamp.url_stamp" alt="">
                    </div>

            </div>
        </div>

        <!-- SABORES -->
        <ProductFlavors
            @addCart="addCart"
        />

        <!-- IMAGEM DA TABELA DE TAMANHOS -->
        <div v-if="item.images.findIndex(el=>el.is_table_size===true) > -1" class="row mt-1 mb-2">
            <div class="col-12 row">
                <template v-for="img in item.images">
                    <div class="mt-2 col-12 col-lg-6" v-if="img.is_table_size==true && img.side == 'LEFT'" :key="img.id">
                        <span data-toggle="modal" :data-target="'#modal-table-size-'+img.id">
                            <img style="width:100%; cursor:pointer;" :data-src="img.url" loading="lazy">
                        </span>

                        <div class="modal fade" :id="'modal-table-size-'+img.id" :aria-labelledby="'modal-table-size-'+img.id" aria-hidden="true">
                            <div class="modal-dialog" style="max-width: auto;">
                                <modal-content class="modal-content" :id="'content-modal-table-size-'+img.id">
                                    <div class="modal-header" style="height:30px; border: none;">
                                        <button type="button" class="close" @click.prevent="$root.closeModalApp('modal-table-size-'+img.id)">&times;</button>
                                    </div>
                                    <div class="modal-body d-flex align-items-center justify-content-center" style="padding: 0; max-height: 100%;">
                                        <img :src="img.url" loading="lazy">
                                    </div>
                                </modal-content>
                            </div>
                        </div>
                    </div>
                    <div class="mt-2 col-12 col-lg-6" v-if="img.is_table_size==true && img.side == 'RIGHT'" :key="img.id">
                        <a data-toggle="modal" :data-target="'#modal-table-size-'+img.id">
                            <img style="width:100%; cursor:pointer;" :data-src="img.url" loading="lazy">
                        </a>

                        <div class="modal fade" :id="'modal-table-size-'+img.id" :aria-labelledby="'modal-table-size-'+img.id" aria-hidden="true">
                            <div class="modal-dialog" style="max-width: auto;">
                                <modal-content class="modal-content" :id="'content-modal-table-size-'+img.id">
                                    <div class="modal-header" style="height:30px; border: none;">
                                        <button type="button" class="close" @click.prevent="$root.closeModalApp('modal-table-size-'+img.id)">&times;</button>
                                    </div>
                                    <div class="modal-body d-flex align-items-center justify-content-center" style="padding: 0; max-height: 100%;">
                                        <img :src="img.url" loading="lazy">
                                    </div>
                                </modal-content>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>

    <!-- PRODUTOS VENDA CASADA -->
    <ProductsToBuyTogether />
</fragment>
</template>

<script>
import LoadingApp from '../LoadingApp.vue'
import ProductActions from './ProductActions.vue'
import Currency from '../../helpers/parseCurrency'
import CalculaFrete from './CalculaFrete.vue'
import InterestFreeInstallments from './InterestFreeInstallments.vue'
import Rating from './Rating.vue'
import {CAncora} from '../Styles/Button/styled'
import { requiredIf } from 'vuelidate/lib/validators'
import { Fragment } from 'vue-fragment'
import { mapActions, mapGetters, mapState } from 'vuex'
import LinkYoutube from './LinkYoutube.vue'
import { CProductTitle, CProductPricePage, CProductWidth } from '../Styles/Product/styled'
import { CModalContent } from '../Styles/Template/styled'
import { CSpan } from '../Styles/Components/styled'
import ProductOptionsConversionUnity from './ProductOptionsConversionUnity.vue'
import ProductItemsGrid from './ProductItemsGrid'
import ProductFlavors from './ProductFlavors.vue'
import { swall } from '../../services/sweetAlert'
import ProductFractionalSale from './ProductFractionalSale'
import ProductsToBuyTogether from './ProductsToBuyTogether'
import ProductSideVariations from './ProductSideVariations'
import ProductPrice from './ProductPrice'
import ShareButton from "./shareButton.vue"

export default {
    name: 'ProductPage',
    components: {
        ProductActions,
        LoadingApp,
        Fragment,
        CalculaFrete,
        LinkYoutube,
        InterestFreeInstallments,
        Rating,
        ProductOptionsConversionUnity,
        ProductItemsGrid,
        ProductFlavors,
        ProductFractionalSale,
        ProductsToBuyTogether,
        ProductSideVariations,
        ProductPrice,
        ShareButton,
        'c-ancora': CAncora,
        'product-title': CProductTitle,
        'product-price-page': CProductPricePage,
        'product-width': CProductWidth,
        'modal-content': CModalContent,
        'c-span': CSpan
    },
    props: {
        product: {
            required: true
        },
        locale_linked_products: {
            type: Number
        },
        products_settings: {
            required: true
        },
        payment_flags: {
            default: Array,
            type: Array
        },
        asset: {
            default: '',
            type: String
        }
    },
    data() {
        return {
            //share: this.$root.$children[0].$attrs.company?.products_settings?.sharing_tools,
            isLoading: false,
            currency: Currency,
            items_grid_id: null,
            item_grid: null,
            // item: this.product,
            itemTieSale: JSON.parse(JSON.stringify(this.product)), // foi preciso para o objeto perder a referência
            linked_products: this.product.linked_products ?? [],
            company_payment: this.$root.$children[0].$attrs.company,
            mediaDesktop: window.matchMedia("(min-width:600px)").matches,
            windowSize: null,
            text_site_color: this.$root.$children[0]?.theme?.text_site_color ?? '#4a505e',
            keyProductImage: 0,
            variation: null
        }
    },
    validations: {
        variation: {
            required: requiredIf(function () {
                return this.variations.length > 0 && this.locale_linked_products == 2
            })
        },
        item_grid: {
            required: requiredIf(function() {
                return this.showItemsGrid
            })
        }
    },
    created() {
        this.ActionSetItem(this.product)
        this.setProductTellMeWhenArrive(this.product)
        this.mediaDesktop = window.matchMedia("(min-width:600px)").matches
        this.media
    },
    mounted() {
        this.setAvailability(this.product.availability)
        this.item.images.sort((x,y) =>{
            if(x.is_table_size ==true){
                let a = x.side.toUpperCase(),
                    b = y.side.toUpperCase()
                return a == b ? 0 : a > b ? 1 : -1;
            }
        })
        if(this.facebookPixel?.settings?.ViewContent == true) {
            fbq('track', 'ViewContent')
        }
        if(this.googleAds?.id != null) {0
            gtag('event', 'view_content', {
                'pageTitle': this.company.nome_fantasia,
                'pageCategory': 'Produto',
                'ecommerce' :{
                    'currency': 'BRL',
                    'value': this.item.pro_price_site,
                    'products': [{
                        'id' : this.item.api_cod_original ?? "",
                        'name': this.item.pro_name_site,
                        'price': this.item.pro_price_site,
                        'brand': this.brand_name ?? ""
                    }],
                }
            })
        }
    },
    methods: {
        ...mapActions("products", [
            "ActionSetItem",
            "ActionSetMinimumQuantity",
            "getAdditionalItems",
            "setAdditionalItems",
            "ActionResetCarousel",
            "setQuantity",
            "setAvailability",
            "setResetItemsGrid",
            "setPriceProduct",
            "ActionSetItemByVariation",
            "setResetProduct",
            "ActionResetAdditionalItems",
            "ActionSetProductPriceToBkpDiscountClosedBox",
            "setMinimumQuantityFractional",
            "setQuantityFractional",
        ]),
        ...mapActions("cart", [
            "ActionSetItemCart",
            "ActionSetItemsCart",
            "ActionAddItemsCart"
        ]),
        ...mapActions("tellMeWhenArrive", ["setProductTellMeWhenArrive"]),
        selectedVariation(variation) {
            jQuery('.product-single-carousel').owlCarousel('destroy');
            setTimeout(() => {
                this.ActionResetCarousel('product-single-carousel');
            }, 10);
            this.ActionSetProductPriceToBkpDiscountClosedBox(variation?.price_to ? JSON.parse(JSON.stringify(variation.price_to)) : null);
            this.ActionSetItemByVariation(variation ? {...variation} : null);
            this.variation = variation ? {...variation} : null;
            this.keyProductImage++;
            this.ActionSetMinimumQuantity();
        },
        showModalProductCustomization() {
            this.getAdditionalItems(this.item.id)
                .then(response => {
                    if(!this.additionalItems.length) {
                        this.setAdditionalItems(response.data)
                    }
                }).catch(error => {
                    swall(error?.msg ?? error)
                })
            this.$root.showModalApp('modal_product_customization');
        },
        validateMaximumPurchaseAmountByUser(item) {
            let priceMaxPurchase = Number(this.client?.maximum_purchase_amount)
            let cartTotalAmount = Number(this.itemsCart?.totalAmount)
            let purchasePrice = (item.pro_qtd * Number(this.item.pro_price_site)) + cartTotalAmount

            if(purchasePrice == priceMaxPurchase) {
                return false
            }

            if(cartTotalAmount > priceMaxPurchase || purchasePrice > priceMaxPurchase) {
                let availableQuantity = (priceMaxPurchase - cartTotalAmount).toFixed(2)
                if(availableQuantity > 0) {
                    swall(`Seu limite restante é de ${this.currency.money(availableQuantity)} em compras!`)
                } else {
                    swall("Valor máximo de compra atingido!")
                }
                return true
            }
            return false
        },
        isInvalidItemGrid(item) {
            if(item.pro_qtd > this.item_grid.quantity && !this.itemsCart.list.length && !this.item.sell_out_of_stock) {
                return true
            }

            if(this.itemsCart.list.length && !this.item.sell_out_of_stock) {
                let qtdItemCart = this.itemsCart.list.find(el => el.items_grid_id == item.items_grid_id && el.id == item.pro_id)
                if(qtdItemCart && item.pro_qtd > (this.item_grid.quantity - qtdItemCart.qtd_cart)) {
                    return true
                }
            }
            return false
        },
        validateSupplier() {
            let cartSupplier = this.itemsCart?.list[0]?.supplier_name
            let supplierProduct = this.item?.suppliers[0]?.supplier_name

                if (this.itemsCart.list.length && supplierProduct != cartSupplier)
                {
                    swall("Já existe outro fornecedor adicionado ao carrinho!")
                    return true
                }
            return false
        },
        async addCart(data) {
            this.isLoading = true
            let redirect_cart = data.redirect_cart

            let item = {
                pro_id: this.item.id,
                pro_qtd: this.quantity,
                type: data.type,
                additionalItems: this.additionalItemsSelected,
                items_grid_id: this.item_grid?.items_grid_id,
                flavors: this.getFlavorsSelected,
                fractional_quantity: this.item.fractional_sale ? this.quantityFractional : null,
                volume_quantity: this.item.volume_quantity
            }

            if (this.$v.$invalid) {
                this.isLoading = false
                this.$v.$touch()
                return
            }

            if (item.items_grid_id && this.isInvalidItemGrid(item)) {
                swall("Quantidade indisponível!")
                return
            }

            if(item.flavors.length < Number(this.minimumAmountOfFlavorsToSelect)) {
                this.isLoading = false
                let message = `
                    Escolha ${
                        Number(this.minimumAmountOfFlavorsToSelect) < Number(this.maximumAmountOfFlavorsToSelect) ?
                        'ao menos' : ''
                    } ${this.minimumAmountOfFlavorsToSelect} ${this.minimumAmountOfFlavorsToSelect > 1 ? 'sabores' : 'sabor'}!
                `
                swall(message, true)
                return
            }

            if(this.atLeastOneAdditionalItemRequired && !(item?.additionalItems?.items?.length > 0)) {
                this.isLoading = false
                swall(
                    `Escolha ${this.getValidationSelectOnlyOneAdditionalItem ? '' : 'ao menos '}um item adicional clicando no botão "Personalize seu produto"`,
                    true
                )
                return
            }

            if(this?.item?.quantity_per_box && this.conversionUnitWhenSellingWithClosedBox == 'CX') {
                item.pro_qtd = Number(item.pro_qtd) * Number(this.item.quantity_per_box)
                item.discount_when_selling_with_closed_box = true
            }

            if(this.item.minimum_sale_quantity) {
                if(item.pro_qtd < this.item.minimum_sale_quantity) {
                    swall(`A quantidade mínima é ${this.item.minimum_sale_quantity} ${this.item.pro_sigla_medida}!`)
                    return
                }
            }
            if(this.itemsCart.list.length && !this.item.sell_out_of_stock) {
                let qtdItemCart = this.itemsCart.list.find(el => el.id == item.pro_id)
                if(qtdItemCart && +item.pro_qtd > (+this.item.pro_stock_site - qtdItemCart.qtd_cart)) {
                    swall("Quantidade indisponível!")
                    return
                }
            }

            if(this.client?.maximum_purchase_amount && this.client.maximum_purchase_amount > 0 && this.validateMaximumPurchaseAmountByUser(item)) {
                return
            }

            if (this.validateSupplier()) {
                return
            }

            if (this.item.is_linked_products && this.variations?.length) {
                let formData = new FormData()

                let arr = [{
                    ...this.item,
                    father_product: this.variations.find(v => v.father_product_id)?.father_product_id ?? null,
                    is_product_group: false,
                    pro_id: this.item.id,
                    pro_qtd: this.quantity,
                }]

                formData.append('itemsCart', JSON.stringify(arr))
                await this.ActionAddItemsCart(formData)
                    .then(async (resp) => {
                        this.isLoading = false
                        if(this.facebookPixel?.settings?.AddToCart == true) {
                            await fbq('track', 'AddToCart', {content_type: 'product', contents: {id: item.pro_id, quantity: Number(item.pro_qtd)}})
                        }
                        if(this.googleAds?.id != null) {
                            const findItem = resp.data.list.find(product => product.id === item.pro_id);
                            gtag('event', 'add_to_cart', {
                                'pageTitle': this.company.nome_fantasia,
                                'ecommerce' : {
                                    'currency': 'BRL',
                                    'value': ((findItem.price_to ?? findItem.pro_price_site) * Number(item.pro_qtd)).toFixed(2),
                                    'products' : [{
                                        'id' : findItem.api_cod_original ?? '',
                                        'name': findItem.pro_name_site,
                                        'discount' : findItem.percentage_discount ?? '',
                                        'quantity' : Number(item.pro_qtd),
                                        'price': (findItem.price_to ?? findItem.pro_price_site).toFixed(2),
                                        'variant': findItem.items_grid_abbreviaton ?? (findItem.grid_group_column_value ?? '' + findItem.grid_group_row_value ?? '')
                                    }],
                                }
                            });
                        }
                        let { data } = resp
                        this.ActionSetItemsCart(data)

                        this.resetItem();
                        if(redirect_cart == true) {
                            window.location.href = this.openCartPage == true ? this.$baseUrl + 'cart' : this.$baseUrl + 'checkout'
                            return
                        }
                        swall('Produto adicionado ao carrinho com sucesso!', false, "check", "success")
                    })
                    .catch((error) => {
                        this.isLoading = false
                        swall(error?.msg ?? error?.message ?? error)
                    })
                return;
            }

            await this.ActionSetItemCart(item)
                .then(async (resp) => {
                    this.isLoading = false
                    if(this.facebookPixel?.settings?.AddToCart == true) {
                        await fbq('track', 'AddToCart', {content_type: 'product', contents: {id: item.pro_id, quantity: Number(item.pro_qtd)}})
                    }
                    if(this.googleAds?.id != null) {
                        const findItem = resp.data.list.find(product => product.id == item.pro_id &&
                        (!item.items_grid_id || product.items_grid_id === item.items_grid_id))
                        gtag('event', 'add_to_cart', {
                            'currency': 'BRL',
                            'value': ((findItem.price_to ?? findItem.pro_price_site) * Number(item.pro_qtd)).toFixed(2),
                            'products' : [{
                                'id' : findItem.api_cod_original,
                                'name': findItem.pro_name_site,
                                'discount' : findItem.percentage_discount,
                                'quantity' : item.pro_qtd,
                                'price': (findItem.price_to ?? findItem.pro_price_site).toFixed(2),
                                'variant': findItem.items_grid_abbreviaton ?? (findItem.grid_group_column_value ?? '' + findItem.grid_group_row_value ?? '')
                            }],
                        });
                    }

                    let { data } = resp
                    this.ActionSetItemsCart(data)
                    this.resetItem();
                    if(redirect_cart == true) {
                        window.location.href = this.openCartPage == true ? this.$baseUrl + 'cart' : this.$baseUrl + 'checkout'
                        return
                    }
                    swall('Produto adicionado ao carrinho com sucesso!', false, "check", "success")
                })
                .catch((error) => {
                    this.isLoading = false
                    swall(error?.msg ?? error)
                })
        },
        initCarouselBootstrap() {
            let el = this.item.images.find(el => el.main == true)
            $('#carouselProductsBootstrap .carousel-item').each(function() {
                $(this).removeClass('active')
            })
            let firstImage = document.getElementById('carousel-item-'+el.id)
            firstImage.classList.add('active')
        },
        controlsIndicatorsSlider(id) {
            $('#carouselProductsBootstrap .carousel-item').each(function() {
                $(this).removeClass('active')
            })
            let imgSlider = document.getElementById('carousel-item-'+id)
            imgSlider.classList.add('active')
        },
        setItemDiscountWhenSellingWithClosedBox(val) {
            if(this?.item?.quantity_per_box && val == 'CX') {
                let itemPercentage = this.productSettings?.discount_percentage_when_closed_box_sale &&
                    this.productSettings.discount_percentage_when_closed_box_sale != 0 ?
                    parseFloat(this.productSettings.discount_percentage_when_closed_box_sale) : null

                let percentage = itemPercentage ?? this.geralDiscountPercentageWhenClosedBoxSale
                if(!percentage || !this?.item?.is_applicable_discount_when_closed_box) {
                    return
                }
                let price = this.item.price_to ?? this.item.pro_price_site
                this.item.price_to = price - price * (percentage / 100)
                return
            }
            this.item.price_to = this.product_price_to_bkp_discount_closed_box
        },
        getPriceFlavor(price_flavor) {
            return this.item.price_to ? price_flavor - (price_flavor * (this.item.percentage_discount / 100)) : price_flavor
        },
        handleSelectItemGrid(itemGrid) {
            this.item_grid = itemGrid
            let data = {
                grid_price: itemGrid?.grid_price_site ?? this.product_pro_price_site_bkp_discount_closed_box
            }
            this.setPriceProduct(data)
        },
        async resetProduct() {
            this.ActionResetAdditionalItems();
            this.ActionSetMinimumQuantity();
            if (this.item.fractional_sale) {
                await this.setMinimumQuantityFractional(this.item);
                this.setQuantityFractional(this.minimumQuantityFractional);
            }
            this.$v.$reset();
        },
        resetItem() {
            if(this.item_grid) {
                this.item_grid = null
            }
            this.setResetItemsGrid(true)
            this.setQuantity(this.minimumQuantity)
            this.setAvailability(this.availability)
            this.flavors.map(flavor => {
                flavor.active = false
                flavor.disabled = false
                return flavor
            })
            this.setResetProduct(true);
            setTimeout(() => {
                this.setResetProduct(false);
            }, 100);
            this.additionalItems.map(el => el.selected = false)
        }
    },
    computed: {
        shareClasses() {
            return (this.share || []).map(s => `a2a_button_${s?.value ?? ''}`)
        },
        share() {
           return this.company?.products_settings?.sharing_tools ?? [{value: 'whatsapp'}]
        },
        ...mapState("company", [
            "company",
            "facebookPixel",
            "googleAds"
        ]),
        ...mapState("cart", [
            "itemsCart"
        ]),
        ...mapState("clients", ["client"]),
        ...mapGetters("company", [
            "showRatings",
            "getShowUnitOfMeasureInProductPrice",
            "showCodeOriginalBesideDescription",
            "showIpi"
        ]),
        ...mapState("products", [
            "conversionUnitWhenSellingWithClosedBox",
            "product_price_to_bkp_discount_closed_box",
            "product_pro_price_site_bkp_discount_closed_box",
            "additionalItemsSelected",
            "additionalItems",
            "item",
            "quantity",
            "minimumQuantity",
            "flavors",
            "variations",
            "reset",
            "quantityFractional",
            "minimumQuantityFractional",
            "availability"
        ]),
        ...mapGetters("products", [
            "getValidationSelectOnlyOneAdditionalItem",
            "getFlavorsSelected",
            "minimumAmountOfFlavorsToSelect",
            "maximumAmountOfFlavorsToSelect",
            "showItemsGrid"
        ]),
        showCodeOriginal() {
            return (
                this.showCodeOriginalBesideDescription &&
                this.item.api_cod_original
            );
        },
        geralDiscountPercentageWhenClosedBoxSale() {
            return this.$root.$children[0].$attrs.company?.products_settings?.discount_percentage_when_closed_box_sale &&
                this.$root.$children[0].$attrs.company.products_settings.discount_percentage_when_closed_box_sale != 0 ?
                parseFloat(this.$root.$children[0].$attrs.company.products_settings.discount_percentage_when_closed_box_sale) : null
        },
        product_name_site() {
            let textTransform = this.$root.$children[0].theme?.products?.product_page?.text_transform_title ?? ''

            return textTransform == 'uppercase' ? this.item.pro_name_site.toUpperCase() :
                textTransform == 'lowercase' ? this.item.pro_name_site.toLowerCase() :
                textTransform == 'initial' ? (this.item.pro_name_site[0].toUpperCase() + this.item.pro_name_site.substr(1).toLowerCase()) :
                textTransform == 'capitalize' ? (this.item.pro_name_site.toLowerCase().replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })) : this.item.pro_name_site
        },
        media() {
            window.onresize = () => {
                this.windowSize = window.innerWidth
                if(window.innerWidth < 600) {
                    this.mediaDesktop = false
                } else {
                    this.mediaDesktop = true
                }
            }
        },
        hasControlsCarousel() {
            let lengthImgsTableSize = this.item.images.filter(el => el.is_table_size == true)
            let lengthImages = this.item.images.length - lengthImgsTableSize.length
            return lengthImages > 1
        },
        hidePrice() {
            let hide = this.company?.settings?.hide_price_not_logged_user ?? false
            return ( hide === false ) ? false : ( hide === true && this.isLogged === false ? true : false )
        },
        isLogged() {
            return this.$root.$children[0].$attrs.logged
        },
        ipi_variation() {
            return ((this.item?.linked_products ? this.item.linked_products.find(el => el.ipi_percentage) : null) ? true : false)
        },
        validateProductGroup() {
            return (this.activateSaleProductGroups && this.isProductGroup)
        },
        isProductGroup() {
            return this.productSettings?.is_product_group ?? false
        },
        productSettings(){
            if(this.item?.settings) {
                return JSON.parse(this.item.settings)
            }
            return null
        },
        activateSaleProductGroups() {
            return this.$root.$children[0].$attrs.company?.settings?.activate_sale_product_groups ?? false
        },
        isProductCustomization() {
            return this.productSettings?.is_product_customization ?? false
        },
        activateProductCustomization() {
            return this.$root.$children[0].$attrs.company?.settings?.activate_product_customization ?? false
        },
        atLeastOneAdditionalItemRequired() {
            return this.productSettings?.at_least_one_additional_item_required ?? false
        },
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false
        },
        maxHeightImage() {
            return this.$root.$children[0].theme?.products?.product_page?.maxheight_image ?? 'none'
        },
        openCartPage() {
            return this.$root.$children[0].theme?.cart.open_cart_page ?? true
        }
    },
    watch: {
        mediaDesktop() {
            jQuery('.product-single-carousel').owlCarousel('destroy')
            setTimeout(() => {
                this.ActionResetCarousel('product-single-carousel')
            }, 10);
            this.keyProductImage++
        },
        conversionUnitWhenSellingWithClosedBox(val) {
            if(!window.location.href.includes('/product/')) {
                return;
            }
            this.ActionSetMinimumQuantity()
            this.setItemDiscountWhenSellingWithClosedBox(val)
        },
        reset(reset) {
            if (reset) {
                this.resetProduct();
            }
        }
    }
}
</script>

<style scoped>
.color-nav-link {
    color:#282d3b !important;
}
.carousel-control-next,
.carousel-control-prev {
    filter: invert(100%);
}
.additional-item-price-box {
    display: block;
}
.additional-item-price-box::after {
    content: "+";
}
.additional-item-price-box:last-child::after {
    content: "";
}

</style>
